var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 43.0714,
    stroke: "#A874EC",
    strokeWidth: 3.85714
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6426 23.1429L34.714 65.5714L41.7854 23.1429",
    stroke: "#A874EC",
    strokeWidth: 3.85714
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2852 65.5714L53.3566 23.1429L60.428 65.5714",
    stroke: "#A874EC",
    strokeWidth: 3.85714
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.edbc193edb2a0b477c22f3d24e4c8af7.svg";
export { ForwardRef as ReactComponent };